/**
 * VCDR Backend Public APIs
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { DetailedVcdsDeploymentInventoryTree } from './detailedVcdsDeploymentInventoryTree';
import { KeyValuePair } from './keyValuePair';
import { DetailedVcdsDeploymentCommerce } from './detailedVcdsDeploymentCommerce';


export interface DetailedVcdsDeploymentAttributes { 
    /**
     * Initial deployment spec
     */
    spec?: { [key: string]: any; };
    commerce?: DetailedVcdsDeploymentCommerce;
    inventory?: DetailedVcdsDeploymentInventoryTree;
    personas?: Array<string>;
    metadata?: Array<KeyValuePair>;
}

